/**
 * FormField Component
 *
 * Compound component for form fields with label, input, hint, and error message.
 * Uses design system classes for consistent styling.
 *
 * Usage:
 * <FormField label="Email" error={errors.email} hint="We'll never share it">
 *   <input type="email" className="input" />
 * </FormField>
 */

import React from 'react';
import PropTypes from 'prop-types';

export function FormField({
  label,
  hint,
  error,
  required,
  children,
  className = '',
  style = {},
  id,
}) {
  // Generate id from label if not provided
  const fieldId = id || (label ? label.toLowerCase().replace(/[^a-z0-9]+/g, '-') : undefined);

  return (
    <div className={`field ${className}`} style={{ marginBottom: 'var(--space-3)', ...style }}>
      {label && (
        <label className="field-label" htmlFor={fieldId}>
          {label}
          {required && <span style={{ color: 'var(--error)' }}> *</span>}
        </label>
      )}
      {children}
      {hint && !error && <span className="field-hint">{hint}</span>}
      {error && <span className="field-error-msg">{error}</span>}
    </div>
  );
}

FormField.propTypes = {
  label: PropTypes.string,
  hint: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};


export default FormField;
